if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener(
              'click',
              this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
            );
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }

        // ✅ Default color filter on load
        const colorName = this._getSelectedColorName();

        // Check if images have alt tags
        const hasTaggedImages = this._hasColorTaggedImages();

        console.log('Initial Selected Color:', colorName);
        console.log('Has Tagged Images:', hasTaggedImages);

        if (hasTaggedImages && colorName) {
          this._hideAllItems();
          this.filterByColor(colorName);
        } else {
          const firstMedia = this.elements.viewer.querySelector('[data-media-id]');
          if (firstMedia) {
            this.setActiveMedia(firstMedia.dataset.mediaId, false);
          }
        }

        // ✅ Variant change listener
        document.addEventListener('change', (event) => {
          const target = event.target;

          if (
            target.matches('variant-selects input[type="radio"]') ||
            target.matches('variant-selects input.swatch-input__input') ||
            target.matches('select')
          ) {
            const selectedColor = this._getSelectedColorName();

            console.log('Variant Changed:', selectedColor);

            this.filterByColor(selectedColor);
          }
        });
      }

      // ✅ Get selected color safely
      _getSelectedColorName() {
        const variantSelects = document.querySelector('variant-selects');

        if (!variantSelects) return '';

        const allInputs = variantSelects.querySelectorAll(
          'input[type="radio"], input.swatch-input__input'
        );

        for (const input of allInputs) {
          if (input.checked) {
            console.log('Checked Variant Input:', input.value);

            return input.value || input.dataset?.variantTitle || '';
          }
        }

        return '';
      }

      // ✅ Check if images contain alt tags
      _hasColorTaggedImages() {
        const imgs = this.elements.viewer.querySelectorAll('li[data-media-id] img');

        for (const img of imgs) {
          const alt = (img.getAttribute('alt') || '').trim();

          console.log('Image ALT:', alt);

          if (alt.length > 0) return true;
        }

        return false;
      }

      // ✅ Hide all items
      _hideAllItems() {
        this.elements.viewer.querySelectorAll('li[data-media-id]').forEach((item) => {
          item.style.display = 'none';
        });

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('li[data-target]').forEach((item) => {
            item.style.display = 'none';
          });
        }
      }

      // ✅ Show all items
      _showAllItems() {
        this.elements.viewer.querySelectorAll('li[data-media-id]').forEach((item) => {
          item.style.display = '';
        });

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('li[data-target]').forEach((item) => {
            item.style.display = '';
          });
        }
      }

      // ✅ Filter images by color
      filterByColor(colorName) {
        console.log('==========================');
        console.log('Selected Variant Color:', colorName);

        if (!colorName) {
          console.log('No color selected');

          this._showAllItems();

          const first = this.elements.viewer.querySelector('[data-media-id]');

          if (first) {
            this.setActiveMedia(first.dataset.mediaId, false);
          }

          return;
        }

        // ✅ Normalize values
        const normalize = (str) =>
          str
            .toLowerCase()
            .replace('grey', 'gray')
            .replace(/\s+/g, ' ')
            .trim();

        const normalizedColor = normalize(colorName);

        console.log('Normalized Variant Color:', normalizedColor);

        const allItems = this.elements.viewer.querySelectorAll('li[data-media-id]');

        const allThumbs = this.elements.thumbnails
          ? this.elements.thumbnails.querySelectorAll('li[data-target]')
          : [];

        let matchCount = 0;

        // ✅ Debug matching
        allItems.forEach((item, index) => {
          const img = item.querySelector('img');

          const alt = img
            ? normalize(img.getAttribute('alt') || '')
            : '';

          const isMatch = alt.includes(normalizedColor);

          console.log(`Image ${index + 1}`);
          console.log('ALT:', alt);
          console.log('MATCH:', isMatch);

          if (isMatch) {
            matchCount++;
          }
        });

        console.log('Total Matches:', matchCount);

        // ✅ If no match show all
        if (matchCount === 0) {
          console.log('No matching images found');

          this._showAllItems();

          const first = this.elements.viewer.querySelector('[data-media-id]');

          if (first) {
            this.setActiveMedia(first.dataset.mediaId, false);
          }

          return;
        }

        // ✅ Show only matched images
        let firstMatchId = null;

        allItems.forEach((item) => {
          const img = item.querySelector('img');

          const alt = img
            ? normalize(img.getAttribute('alt') || '')
            : '';

          const isMatch = alt.includes(normalizedColor);

          item.style.display = isMatch ? '' : 'none';

          if (isMatch && !firstMatchId) {
            firstMatchId = item.dataset.mediaId;
          }
        });

        // ✅ Thumbnail filter
        allThumbs.forEach((thumb) => {
          const img = thumb.querySelector('img');

          const alt = img
            ? normalize(img.getAttribute('alt') || '')
            : '';

          const isMatch = alt.includes(normalizedColor);

          thumb.style.display = isMatch ? '' : 'none';
        });

        console.log('First Match Media ID:', firstMatchId);

        if (firstMatchId) {
          this.setActiveMedia(firstMatchId, false);
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );

            if (
              activeThumbnail &&
              activeThumbnail.parentElement.firstChild !== activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        this.setActiveThumbnail(activeThumbnail);

        if (activeThumbnail) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });

        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia = activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}